import { render, staticRenderFns } from "./DefaultDateInput.vue?vue&type=template&id=d5836f72&"
import script from "./DefaultDateInput.vue?vue&type=script&lang=js&"
export * from "./DefaultDateInput.vue?vue&type=script&lang=js&"
import style0 from "./DefaultDateInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports